"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.chat.nomodel': 'Wybierz model, aby rozpocząć czat',
};
